<template>
  <div>
    <div class="LogoWrap">
      <div class="logoBox">
        <img src="@/assets/logo_text.svg" alt="" />
      </div>
    </div>
    <div class="TopContentsWrap">
      <div class="LeftWrap">
        <div>
          <p>
            가장 신뢰할 수 있는
          </p>
          <p class="mt4">
            가상자산거래소
          </p>
          <p class="bold Title">
            플라이빗
          </p>
        </div>
        <div>
          <button @click="clickAppDownload" class="DownloadButton">
            앱 다운로드
          </button>
        </div>
      </div>
      <div class="RightWrap">
        <img src="@/assets/img/main/mockup_shadow_20.png" alt="" />
      </div>
    </div>
    <div class="MidContentsWrap">
      <div class="NotiWrap">
        <div class="Highlight Noti">공지</div>
        <div class="NotiContent">
          <a :href="noticeItem.link" target="_blank">
            <p>
              {{ noticeItem.title }}
            </p>
          </a>
        </div>
      </div>

      <div class="BannerWrap">
        <MainEvent />
      </div>
    </div>
    <div class="TitleWrap" flex fjb>
      <div class="CoinNameWrap">코인명</div>
      <div class="CoinAmountWrap">시세</div>
      <div class="CoinRatioWrap">변동률</div>
      <div class="CoinPriceWrap">거래액</div>
    </div>
    <div v-if="addListArray.length > 0" class="BottomContentsWrap">
      <div v-for="(list, index) in addListArray" :key="index" class="ItemsWrap">
        <div
          v-if="
            list.onViewEnable === 'Y' && list.coinInfo && list.currentPricesInfo
          "
          class="Item"
        >
          <ul class="ListWrap">
            <!-- 코인명 -->
            <li class="List CoinNameWrap">
              <div class="CoinNameBox">
                <!-- <img
                  :src="
                    `//static.flybit.com/static/img/mobile/coin_${
                      list.code.split('-')[1]
                    }.png`
                  "
                  :alt="`${list.code}`"
                /> -->
                <div>
                  <div flex class="TopNameBox">
                    <div class="bold CoinName">
                      {{ getCoinNameByMarkets(list.dealCoinCode) }}
                    </div>
                    <img
                      v-if="list.label"
                      :src="
                        require(`@/assets/img/common/${
                          list.label === '!' ? 'W' : list.label
                        }.svg`)
                      "
                      alt=""
                      class="badge"
                    />
                  </div>
                  <p class="subText">
                    {{ list.dealCoinCode }}/{{ list.baseCoinCode }}
                  </p>
                </div>
              </div>
            </li>
            <!-- 시세 -->
            <li
              class="CoinAmountWrap"
              :id="list.code.split('-')[1]"
              :class="
                list.code.split('-')[1] === list.tickCoin ? list.tickType : ''
              "
            >
              <div>
                <div
                  :class="
                    Number(
                      amountRatio(
                        list.currentPricesInfo.b_close,
                        list.currentPricesInfo.price
                      )
                    ) | rbClass
                  "
                >
                  <div>
                    {{ coinAmountFormat(list.currentPricesInfo.price || 0) }}
                  </div>
                  <div class="subText">
                    {{
                      priceToKrwFormat(
                        list.currentPricesInfo.price || 0,
                        list.dealCoinCode
                      )
                    }}KRW
                  </div>
                </div>
              </div>
            </li>
            <!-- 변동률 -->
            <li
              class="CoinRatioWrap
            "
              :class="
                Number(
                  amountRatio(
                    list.currentPricesInfo.b_close,
                    list.currentPricesInfo.price
                  )
                ) | rbClass
              "
            >
              {{
                amountRatio(
                  list.currentPricesInfo.b_close,
                  list.currentPricesInfo.price
                ) > 0
                  ? "+" +
                    amountRatio(
                      list.currentPricesInfo.b_close,
                      list.currentPricesInfo.price
                    )
                  : amountRatio(
                      list.currentPricesInfo.b_close,
                      list.currentPricesInfo.price
                    )
              }}%
            </li>
            <!-- 거래액 -->
            <li class="CoinPriceWrap">
              <p>
                {{
                  coinAmountFormat(list.currentPricesInfo.acc_amount.toFixed(0))
                }}
              </p>
              <p class="subText">
                {{ totalAmount(list.currentPricesInfo.acc_amount) }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="BottomContentsWrap pt50 pb50" style="text-align: center">
      내용이 없습니다.
    </div>
    <div class="Advertisement">
      <div class="AdvertisementWrapTitle" style="margin-top: 20px;">국제표준 및 국내 보안 인증 획득으로</div>
      <div class="AdvertisementWrapSmallTitle">주요 자산을 안전하게 보호합니다.</div>
      <div class="ContentsWrap">
        <div>
          <a href="https://static.dev.flybit.com/static/img/ISMS-P-2022-ENG.pdf" target="_black">
            <img style="width: 135px;, height: 95px;" src="@/assets/img/main/ISMSP_logo.png" alt="" />
            <p class="Desc bold">
              정보보호 인증(ISMS-P)
            </p>
            <p style="margin-top: 10px;font-size: 12px; color: #666666;">2022.12.07 ~ 2025.12.06<br/>가상자산 거래소 운영</p>
          </a>
        </div>

        <div>
          <a href="https://static.dev.flybit.com/static/img/ISO27001-ENG.pdf" target="_black">
            <img style="width: 95px;, height: 95px;" src="@/assets/img/main/iso1-logo.png" alt="" />
            <p class="Desc bold">
              ISO 27001
            </p>
          </a>
        </div>
      </div>

      <div class="ContentsWrap" style="padding-left: 30px;">
        <div>
          <a href="https://static.dev.flybit.com/static/img/ISO27701-ENG.pdf" target="_black">
            <img style="width: 95px;, height: 95px;" src="@/assets/img/main/iso2-logo.png" alt="" />
            <p class="Desc bold">
              ISO 27701
            </p>
          </a>
        </div>

        <div style="margin-left: 40px;">
          <a href="https://isds.kisa.or.kr/kr/publish/view.do?menuNo=204942&publishNo=1432&pageNum=1&limit=10&type=ALL&keyword=" target="_black">
            <img style="width: 153.3px;, height: 95px;" src="@/assets/img/main/img_information_security_2.png" alt="" />
            <p class="Desc bold">
              정보보호 공시
            </p>
          </a>
        </div>
      </div>

      <div class="AdvertisementWrapTitle">글로벌 기준에 부합하는 컴플라이언스</div>
      <div class="AdvertisementWrapSmallTitle">및 리스크 대응 체계를 갖추고 있습니다.</div>

      <div class="ContentsWrap" style="margin-top: 30px; margin-bottom: 100px; padding-left: 30px;">
        <div>
          <a href="https://static.flybit.com/static/img/37301_certificate_kor.pdf" target="_black">
            <img style="width: 95px;, height: 95px;" src="@/assets/img/main/ICR-logo.png" alt="" />
            <p class="Desc bold">
              ISO 37301
            </p>
          </a>
        </div>

        <div style="margin-left: 40px;">
          <a href="https://static.flybit.com/static/img/37001_certificate_kor.pdf" target="_black">
            <img style="width: 135px;, height: 95px;" src="@/assets/img/main/KAB-logo.png" alt="" />
            <p class="Desc bold">
              ISO 37001
            </p>
          </a>
        </div>
      </div>

      <div class="imgCardContainer">
        <div class="imgCardTextContainer" style="width: 360px;">
          <div class="imgCardText bold">거래는 간편하게</div>
          <div class="imgCardText bold">자산은 안전하게</div>
          <div class="imgCardSmallText bold">고객 자산은 소중하니까</div>
        </div>
        <div class="imgContainer">
          <div class="imgBoxWrap">
            <!-- <img src="@/assets/img/main/m_card01.png" alt="">
            <img src="@/assets/img/main/m_card02.png" alt=""></img> -->
            <div class="imgBox">
              <div class="imgTitle">월렛보안</div>
              <img style="width: 140px; height: 120px;" src="@/assets/img/main/imags_m_cardimg_01.png" alt="">
              <div style="margin-top: 34px;" class="imgTextContain">
                <div style="font-size: 18px; font-weight: bold;">고객 자산의 70% 이상을</div>
                <div style="font-size: 18px">안전하게 콜드월렛에 보관</div>
              </div>
            </div>
            <div class="imgBox">
              <div class="imgTitle">개인정보 관리보안</div>
              <div style="display: flex; flex-direction: column; align-items: center;">
                <img style="width: 140px; height: 120px;" src="@/assets/img/main/imags_m_cardimg_02.png" alt="">
                <img style="margin-top: 10px; width: 100px; height: 15px;" src="@/assets/img/main/img_meritzlogo.png" alt="">
              </div>
              <div class="imgTextContain">
                <div style="font-size: 18px; font-weight: bold;">안전한 개인정보 보호를 위해</div>
                <div style="font-size: 18px">손해배상책임보험에 가입</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Decimal from "decimal.js";
import Api from "@/common/Api";
import Store from "@/store/";
import MainEvent from "./MainEvent.vue";

import * as _ from "lodash";
import numbro from "numbro";

export default {
  name: "Main",
  components: {
    MainEvent,
  },
  created() {
    this.getMarketsLists();
    this.getNotice();
  },
  mounted() {
    this.socketInit();
  },
  data() {
    return {
      noticeItem: {
        title: "내용이 없습니다.",
        link: "",
      },
      currentPrices: [],
      getCoinInfo: [],
      marketLists: [],
      addListArray: [],
      refresh: false,
      loadList: false,
      loadEnd: false,
      noticeModalChx: false,
      noticeModal: {
        show: false,
        title: "",
        contents: "",
      },
      // showContent: false,
      downloadBanner: true, //안드로이드앱 다운 유도 배너
      popupAuthGuide: false,
      // showContent: false,
      reauthdate: "", //재이행주기 도래일
      krwPrice: 0,
      getCoinCode: "",
      getCoinType: "",
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["toKRW"]),
  },
  methods: {
    clickAppDownload() {
      location.href = "https://applink.flybit.com/open";

      // this.$router.push({ name: "openLinkPage" });
    },
    changeMarketPrice(data) {
      this.addListArray.forEach((value, i) => {
        if(value.onViewEnable === 'Y' && value.coinInfo && value.currentPricesInfo && value.id === data.MKIDX) {
          value.currentPricesInfo.price = data.PRICE
          value.currentPricesInfo.acc_amount = new Decimal(value.currentPricesInfo.acc_amount || 0).add(new Decimal(data.PRICE).mul(data.QTY))
        }
      })
    },
    setBorderStyleToPriceCell(COIN, TYPE) {
      // TODO: ticker socket 생기면 교체필요
      // const takerList = lastTradeCM.T_MAKETAKE === 'T';
      // if (takerList.length < 1) {
      //   return;
      // }
      const target = document.getElementById(COIN);
      if (!target) {
        return;
      }
      if (
        target.style.border.match(`#eb3246`) ||
        target.style.border.match(`#1655a7`)
      ) {
        return;
      }
      target.style.border =
        TYPE === "B" ? `1px solid #eb3246` : `1px solid #1655a7`;
      setTimeout(() => this.resetBorderStyleToPriceCell(target), 300);
    },

    resetBorderStyleToPriceCell(target) {
      if (!target) {
        return;
      }
      target.style.border = `1px solid transparent`;
    },
    async getNotice() {
      try {
        const res = await Api.Board.getItems({ type: 4, count: 1 });
        this.noticeItem = res.data.result[0];
      } catch (error) {
        console.log("error", error);
      }
    },
    async getMarketsLists(tickCoin, tickType) {
      try {
        const res = await Api.Markets.getMarketsLists();
        this.marketLists = res.data.result;
        await this.getCoinsInfo();
        await this.getCurrentPricesLists();
        const test = this.marketLists.map((list) => {
          return {
            ...list,
            tickCoin: tickCoin,
            tickType:
              tickType === "B" ? "redBox" : tickType === "S" ? "blueBox" : "",
            coinInfo: this.getCoinInfo.filter(
              (coin) => coin.code === list.dealCoinCode
            )[0],
            currentPricesInfo: this.currentPrices.find(
              (price) => price.coin.split(".")[0] === list.dealCoinCode
            ),
          };
        });

        this.addListArray = _.orderBy(
          test,
          ["topYn", "currentPricesInfo[acc_amount]", "sort"],
          ["desc", "desc", "asc"]
        );

        // console.log("addListArray", this.addListArray);
        return this.addListArray;
      } catch (error) {
        this.marketLists = null;
      }
    },
    async getCurrentPricesLists() {
      try {
        const res = await Api.Trade.getCurrentPriceTotal();
        this.currentPrices = res.data.result;
      } catch (error) {
        this.currentPrices = null;
      }
    },
    async getCoinsInfo() {
      try {
        const res = await Api.Transfer.getCoinsInfo();
        this.getCoinInfo = res.data.result;
      } catch (error) {
        this.getCoinInfo = null;
      }
    },
    getCoinNameByMarkets(code) {
      const coinInfo =
        this.getCoinInfo.find((coin) => coin.code === code) || {};
      return coinInfo.name;
    },
    priceToKrwFormat(price) {
      const KrwPrice = Decimal(this.krwPrice)
        .mul(price)
        .floor()
        .toNumber();
      return numbro(KrwPrice).format({ thousandSeparated: true });
    },
    coinAmountFormat(amount) {
      return numbro(amount).format({ thousandSeparated: true });
    },
    amountRatio(close, price) {
      if (close === 0 && price === 0) {
        return "0.00";
      }
      const res = Decimal(price)
        .minus(close)
        .div(close)
        .mul(100)
        .toNumber()
        .toFixed(2, Decimal.ROUND_DOWN);

      if (res.indexOf("0.00") > -1) {
        return "0.00";
      }

      return res;
    },
    socketInit() {
      const checkDevServer =
        window.location.href.includes("dev.") ||
        window.location.href.includes("local.");
      const SOKET_URL_DEV = `wss://ws.dev.flybit.com/io`;
      const SOKET_URL_LIVE = `wss://ws.flybit.com/io`;
      const PINGPONG_INTERVAL = 30000;
      const _this = this;
      const socket = checkDevServer
        ? new WebSocket(SOKET_URL_DEV)
        : new WebSocket(SOKET_URL_LIVE);
      // const socket = new WebSocket(SOKET_URL_LIVE);

      let ping;
      const pingpong = () => {
        const sendPingPongData = { channel: "ping" };
        socket.send(JSON.stringify(sendPingPongData));
        ping = setTimeout(pingpong, PINGPONG_INTERVAL);
      };

      const socketInfo = {
        channel: "eventSub",
        data: {
          events: ["tick", "krw"],
          id: 0,
          mkidx: [], // TradeCM 구독용, 빈칸은 전체구독
          mkname: [], // TradeInit 구독용
        },
      };
      socket.addEventListener("open", function(event) {
        socket.send(JSON.stringify(socketInfo));
        ping = setTimeout(pingpong, PINGPONG_INTERVAL);
      });

      socket.addEventListener("message", async function(event) {
        const blobParse = await new Blob([event.data], {
          type: "text/plain",
        }).text();
        const data = JSON.parse(blobParse);
        const setSocketEvent = (lastMessage) => {
          const { event } = lastMessage;
          const { result } = lastMessage;
          if (event === "krw") {
            _this.krwPrice = result.price;
            // price인지 tradeCM인지 확인차 로그 추가
          }
          // 체결정보
          else if (event === "tick") {
            // console.log("websocket-tick");
            const tickCoinCode = result.COIN.split(".")[0];
            _this.setBorderStyleToPriceCell(tickCoinCode, result.TYPE);
            _this.changeMarketPrice(result)
            // _this.getMarketsLists();
          }
          if (event === "update") {
            // 가격 -> price가 tradeCM 으로 변경
            // 서버점검
            if (result.event === "server") {
              location.replace("/");
              Store.commit("SET_SERVER_STATUS", false);
              Store.commit("SET_SERVER_MESSAGE", lastMessage);
              return;
            }
            // 새로고침
            else if (result.event === "refresh") {
              window.location.reload();
            }
            // 에러이벤트
            else if (result.event === "error") {
              console.log("error");
            }
          }
        };
        setSocketEvent(data);
      });
    },
    totalAmount(total) {
      const setTotal = Decimal(this.krwPrice)
        .mul(total)
        .round()
        .toString();
      const splitTotal = setTotal.split(".")[0];
      if (splitTotal.length > 6) {
        if (Number(splitTotal.slice(-6)[0]) > 4) {
          return Number(splitTotal.split(splitTotal.slice(-6))[0]) + 1 + "백만";
        } else {
          return splitTotal.split(splitTotal.slice(-6))[0] + "백만";
        }
      }
      return numbro(setTotal).format({ thousandSeparated: true });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/color_palette.scss";
.Highlight {
  color: $Red500;
}
.bold {
  font-weight: bold;
}
.subText {
  font-size: 12px;
  color: $WarmBlack500;
}
.LogoWrap {
  padding: 24px 24px 0;
  background-color: $BlueGray100;
  .logoBox {
    img {
      width: 100px;
    }
  }
}
.TopContentsWrap {
  display: flex;
  justify-content: space-between;
  padding: 12px 10px 0 24px;
  font-size: 14px;
  background-color: $BlueGray100;

  .LeftWrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 0;
    font-size: 16px;
    font-weight: 600;
    .Title {
      margin-top: 8px;
      font-size: 20px;
      font-weight: bold;
    }
    p {
      &:first-of-type {
        margin-top: 0;
      }
    }
    .DownloadButton {
      margin-top: 20px;
    }
  }
  .RightWrap {
    display: flex;
    align-items: center;
    width: 182px;
    img {
      width: 100%;
    }
  }
}


.MidContentsWrap {
  .NotiWrap {
    display: flex;
    align-items: center;
    padding: 12px;
    border-top: 1px solid $BlueGray400;
    border-bottom: 1px solid $BlueGray400;
    font-size: 14px;
    .Noti {
      width: 30px;
    }
    .NotiContent {
      width: calc(100% - 18px);
      margin-left: 12px;
    }
    a {
      line-height: 1;
    }
  }
  .BannerWrap {
    padding: 12px;
  }
}
.TitleWrap {
  padding: 0 12px;
  border-top: 1px solid $BlueGray400;
}
.BottomContentsWrap {
  padding: 0 12px 16px;
  border-top: 1px solid $BlueGray400;
  .ItemsWrap {
    .Item {
      padding: 4px 0;
      border-bottom: 1px solid $BlueGray400;
    }
    &:last-of-type {
      .Item {
        border-bottom: 0;
      }
    }
  }
  .ListWrap {
    display: flex;
    list-style: none;
    .List {
      display: flex;
      justify-content: space-between;
    }
  }
}
.CoinNameWrap {
  flex: 3.3;
  padding: 8px 8px 8px 0;
  text-align: left;
  .CoinNameBox {
    display: flex;
    align-items: center;
    .badge {
      width: 18px;
      height: 18px;
      flex: 1;
    }
    .CoinName {
      flex: 9;
    }
  }
}
@keyframes borderColorRed {
  0% {
    border-color: $Red500;
  }
  70% {
    border-color: $Red500;
  }
  100% {
    border-color: transparent;
  }
}
@keyframes borderColorBlue {
  0% {
    border-color: $Blue500;
  }
  70% {
    border-color: $Blue500;
  }
  100% {
    border-color: transparent;
  }
}
.CoinAmountWrap {
  flex: 2.7;
  padding: 8px 4px;
  text-align: right;
  border: 1px solid transparent;

  &.default {
    border: 0px;
  }
  &.RedBox {
    border-color: $Red500;
    animation: borderColorRed 0.5s;
    animation-iteration-count: 1;
  }
  &.blueBox {
    border-color: $Blue500;
    animation: borderColorBlue 0.5s;
    animation-iteration-count: 1;
  }
}
.CoinRatioWrap {
  flex: 2;
  padding: 8px;
  text-align: right;
}

.Advertisement {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 30px 0 0 0;
  background-color: $BlueGray300;
  text-align: center;

  .AdvertisementWrapTitle {
      margin-top: 45px;
      font-size: 18px;
      font-weight: bold;
    }
  .AdvertisementWrapSmallTitle {
      margin-top: 8px;
      font-size: 16px;
      font-weight: bold;
    }
  .ContentsWrap {
    margin-top: 47px;
    display: flex;
    justify-content: space-around;

    .Desc {
      margin-top: 10px;
      font-size: 14px;
    }
    img {
      margin: 12px auto 0;
    }
    .logo-wrap {
      display: flex;
      justify-content: space-between;
      img {
        width: 45%;
      }
    }
  }
}

.imgCardContainer {
  background-color: white;
}

.imgCardTextContainer {
  margin:auto;
  margin-top: 100px;
  .imgCardText {
    margin-bottom: 6px;
    letter-spacing: 0.5%;
    font-size: 26px;
  }
  .imgCardSmallText {
    margin-top: 10px;
    font-size: 18px;
    color: #aaaaaa;
  }
}

.imgContainer {
  margin: 50px 0 100px 0;
  overflow-x: auto;

  -ms-overflow-style: none;
  scrollbar-width: none;

  /* margin: auto;
    width: 582px;
    height: 330px;
    display: flex;
    justify-content: space-around; */

  .imgBoxWrap {
    margin: auto;
    width: 582px;
    height: 330px;
    display: flex;
    justify-content: space-around;
    .imgBox {
      width: 260px;
      height: 330px;
      border: 1px solid #ebebeb;
      border-radius: 16px;

    .imgTitle {
      margin: 30px 0 30px 30px;
      padding: 5px 20px 5px 20px;
      width: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #404040;
      color: #ffffff;
      border-radius: 15px;
    }
    .imgTextContain {
      margin-top: 10px;
    }
    }
  }
}

.imgContainer::-webkit-scrollbar {
    display: none;
  }


.CoinRatioWrap {
  flex: 2;
}
.CoinPriceWrap {
  flex: 2;
  padding: 8px 0 8px 8px;
  text-align: right;
}
p {
  margin-bottom: 0;
}
@media screen and (max-width: 360px) {
  .LogoWrap {
    padding: 8px;
    .logoBox {
      img {
        width: 80px;
      }
    }
  }
  .subText {
    font-size: 11px;
  }
  .TopContentsWrap {
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 8px 8px 0 8px;
    .LeftWrap {
      align-items: center;
      padding: 10px 0 0;
      font-size: 16px;
      .DownloadButton {
        margin-top: 12px;
      }
    }
    .RightWrap {
      margin-top: 4px;
    }
  }
  .MidContentsWrap {
    .NotiWrap {
      .NotiContent {
        width: calc(100% - 22px);
      }
    }
    .BannerWrap {
      padding: 8px;
    }
  }

  .BottomContentsWrap {
    padding: 0 8px 16px;
  }
  .CoinNameWrap {
    .CoinNameBox {
      align-items: center;
      .badge {
        width: 16px;
        height: 16px;
      }
    }
  }
  .TitleWrap {
    padding: 0 8px;
  }
  .CoinNameWrap {
    flex: 3;
    padding: 8px 2.5px 8px 0;
  }
  .CoinAmountWrap {
    flex: 2.8;
    padding: 8px 2.5px;
  }
  .CoinRatioWrap {
    flex: 2.4;
    padding: 8px 2.5px;
  }
  .CoinPriceWrap {
    flex: 1.8;
    padding: 8px 0 8px 2.5px;
  }
}
@media screen and (max-width: 280px) {
  .subText {
    font-size: 10px;
  }
  .CoinNameWrap {
    .CoinNameBox {
      align-items: center;
      .badge {
        width: 14px;
        height: 14px;
      }
    }
  }
  .CoinNameWrap {
    flex: 2.6;
  }
  .CoinAmountWrap {
    flex: 2.7;
  }
  .CoinRatioWrap {
    flex: 2.4;
  }
  .CoinPriceWrap {
    flex: 1.8;
  }
  .MidContentsWrap {
    .NotiWrap {
      .NotiContent {
        width: calc(100% - 25px);
      }
    }
  }
}
</style>
